import * as React from 'react';
import { ResizeGroupBase } from './ResizeGroup.base';
import type { IResizeGroupProps } from './ResizeGroup.types';

export const ResizeGroup: React.FunctionComponent<IResizeGroupProps> = ResizeGroupBase;
